import React, { useState } from "react";
import TablePagination from "../Common/table/TablePagination";
import CrmTableContent from "../Common/table/CrmTableContent";
import Chart from "react-apexcharts";

const RatioTables = ({ data, funnalStages }) => {
  console.log("funnalStages", funnalStages);

const [chartState, setChartState] = useState({
  series: [{
    name: "Leads count",
    data: funnalStages?.filter(obj => obj.leadCount)?.map(obj => obj.leadCount),
  }],
  options: {
    chart: {
      type: "bar",
      height: 350,
      stacked: true, // Essential for step funnel
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
        barHeight: "100%",
        isFunnel: false,
        dataLabels: {
          position: 'center', // Center labels in each step
        }
      },
    },
    colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#3F51B5'],
    dataLabels: {
      enabled: true,
      formatter: function(val, opt) {
        const total = Math.max(...opt.w.globals.series[0]); // Get max value for percentage
        const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : '0';
        return `${opt.w.globals.labels[opt.dataPointIndex]}\n${val} (${percentage}%)`;
      },
      style: {
        fontSize: '10px',
        fontWeight: 'bold',
        colors: ['#fff']
      },
    },
    title: {
      text: "Sales Funnel Steps",
      align: "center",
    },
    xaxis: {
      categories: funnalStages?.filter(obj => obj.leadCount)?.map(obj => obj.name),
    },
    legend: {
      show: false,
    },
    responsive: [
      // Keep your existing responsive breakpoints
    ],
  },
});
  return (
    <div className="joining_Teammbr_section">

      <div className="row">
        <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12">
          {" "}
          {/* Changed sm-5 to sm-12 for better mobile view */}
          <div
            className="crm_panel_body__31wq1 pannel-sec"
            style={{ minHeight: "205px", padding: "15px" }}
          >
            <div
              className="chart-wrapper"
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                minHeight: "200px",
              }}
            >
          
              <Chart
                options={{
                  ...chartState.options,
                  // responsive: [
                  //   {
                  //     breakpoint: 768,
                  //     options: {
                  //       chart: { height: 250 },
                  //       dataLabels: { fontSize: "10px" },
                  //       plotOptions: {
                  //         bar: { barHeight: "70%" },
                  //       },
                  //     },
                  //   },
                  //   {
                  //     breakpoint: 480,
                  //     options: {
                  //       chart: { height: 200 },
                  //       dataLabels: { enabled: false }, // Hide labels on very small screens
                  //       xaxis: { labels: { show: false } }, // Optionally hide x-axis labels
                  //       yaxis: { labels: { style: { fontSize: "10px" } } },
                  //     },
                  //   },
                  // ],
                }}
                series={chartState.series}
                type="bar"
                height="350"
                width="100%"
              />
            </div>
          </div>
        </div>
      <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12">
  <div className="crm_panel_body__31wq1 pannel-sec" style={{ 
    minHeight: "205px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    padding: "20px"
  }}>
    <legend >
      <span>Sales Effectiveness Ratios</span>
    </legend>

    <div className="crm_table_responsive__cut_1 table-responsive" style={{ 
      overflowX: "auto", 
      width: "100%",
      borderRadius: "8px",
      border: "1px solid #f0f0f0"
    }}>
      <table className="table follow-up-table" style={{ 
        minWidth: "1000px",
        borderCollapse: "separate",
        borderSpacing: "0",
        fontFamily: "'Inter', sans-serif"
      }}>
        <thead>
          <tr style={{
            backgroundColor: "#89786",
            color: "white",
            position: "sticky",
            top: "0"
          }}>
            <th style={{
              padding: "15px",
              textAlign: "center",
              borderTopLeftRadius: "8px",
              fontWeight: "600"
            }}>Sales Funnel Stage</th>
            <th style={{ padding: "15px", textAlign: "center", fontWeight: "600" }}>Prospecting</th>
            <th style={{ padding: "15px", textAlign: "center", fontWeight: "600" }}>Scheduled Presentation</th>
            <th style={{ padding: "15px", textAlign: "center", fontWeight: "600" }}>Effective Presentation</th>
            <th style={{ padding: "15px", textAlign: "center", fontWeight: "600" }}>Scheduled Project Visit</th>
            <th style={{ padding: "15px", textAlign: "center", fontWeight: "600" }}>Effective Project Visits</th>
            <th style={{ 
              padding: "15px", 
              textAlign: "center", 
              fontWeight: "600",
              borderTopRightRadius: "8px"
            }}>Amount of Deposits</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ backgroundColor: "#f8f9fa" }}>
            <td style={{
              padding: "12px",
              textAlign: "center",
              fontWeight: "600",
              color: "#4a4a4a",
              backgroundColor: "#f6f4fe"
            }}>Effective Ratio</td>
            <td style={{
              padding: "12px",
              textAlign: "center",
              backgroundColor: "rgba(108, 92, 231, 0.1)",
              color: "#6c5ce7",
              fontWeight: "600"
            }}>{data?.prospectingEffectiveRatio}</td>
            <td style={{
              padding: "12px",
              textAlign: "center",
              backgroundColor: "rgba(0, 184, 148, 0.1)",
              color: "#00b894",
              fontWeight: "600"
            }}>{data?.scheduledEffectiveRatio}</td>
            <td style={{
              padding: "12px",
              textAlign: "center",
              backgroundColor: "rgba(253, 203, 110, 0.1)",
              color: "#fdcb6e",
              fontWeight: "600"
            }}>{data?.effectivePresentationRatio}</td>
            <td style={{
              padding: "12px",
              textAlign: "center",
              backgroundColor: "rgba(225, 112, 85, 0.1)",
              color: "#e17055",
              fontWeight: "600"
            }}>{data?.effectiveProjectfvisitRatio}</td>
            <td style={{
              padding: "12px",
              textAlign: "center",
              backgroundColor: "rgba(129, 236, 236, 0.1)",
              color: "#81ecec",
              fontWeight: "600"
            }}>{data?.amountDepositRatio}</td>
            <td style={{
              padding: "12px",
              textAlign: "center",
              backgroundColor: "rgba(232, 67, 147, 0.1)",
              color: "#e84393",
              fontWeight: "600"
            }}>{data?.amountInitialpaymentRatio}</td>
          </tr>
          <tr>
            <td style={{
              padding: "12px",
              textAlign: "center",
              fontWeight: "600",
              color: "#4a4a4a",
              backgroundColor: "#f6f4fe"
            }}>Sales Funnel Stage</td>
            <td style={{ padding: "12px", textAlign: "center" }}>Scheduled Presentation</td>
            <td style={{ padding: "12px", textAlign: "center" }}>Effective Presentation</td>
            <td style={{ padding: "12px", textAlign: "center" }}>Scheduled Project Visit</td>
            <td style={{ padding: "12px", textAlign: "center" }}>Effective Project Visits</td>
            <td style={{ padding: "12px", textAlign: "center" }}>Amount of Deposits</td>
            <td style={{ padding: "12px", textAlign: "center" }}>Amount of Initial Installment Paid</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
      </div>
    </div>
  );
};

export default RatioTables;
